import  { useState, useEffect } from 'react';
import { Fab } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { ORANGE, ORANGE_HOVER } from './global_varibles';

function ScrollToTopButton() {
  const [isVisible, setIsVisible] = useState(false);

  // Show button when page is scrolled down
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Scroll to the top when the button is clicked
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  return (
    isVisible && (
      <Fab
        onClick={scrollToTop}
        sx={{
          position: 'fixed',
          bottom: 16,
          right: 16,
          background: `linear-gradient(135deg, ${ORANGE} 0%, ${ORANGE_HOVER} 100%)`,
          color: '#fff',
          '&:hover': {
            background: `linear-gradient(135deg, ${ORANGE_HOVER} 0%, #d97706 100%)`,
          },
        }}
      >
        <KeyboardArrowUpIcon />
      </Fab>
    )
  );
}

export default ScrollToTopButton;
